import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: 'linear-gradient(to bottom,#f3f3f3,#e2e2e2)'
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  grow: {
    flexGrow: 1,
  },
  orange: {
    backgroundColor: '#f57e2a'
  },
  logo: {
    height: '32px',
    width: 'auto'
  },
  title: {
    marginLeft: theme.spacing(2),
    flexGrow: 1,
    fontSize: '1rem'
  },
  toolbar: {
    minHeight: '48px',
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  }
}));

export default function Header(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar color={'default'} position="relative">
        <Toolbar className={classes.toolbar}>
          <span>
              <img className={classes.logo} src={props?.orgData?.logo} alt={props?.orgData?.displayName} />
          </span>
          {props.title && (
            <Typography variant="h6" className={classes.title}>
              {props.title}
            </Typography>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
}
